import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ZoomInIcon } from 'lucide-react';
interface ImageGalleryProps {
  images: string[];
}
export function ImageGallery({
  images
}: ImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  return <>
      <motion.div initial={{
      opacity: 0,
      y: 5
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.2
    }} className="grid grid-cols-2 gap-2" data-id="element-314">
        {images.map((image, index) => <button key={index} onClick={() => setSelectedImage(image)} className="relative group rounded-lg overflow-hidden bg-slate-900 border border-slate-700 hover:border-blue-500/50 transition-all" data-id="element-315">
            <img src={image} alt={`Image ${index + 1}`} className="w-full h-32 object-cover" data-id="element-316" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-317">
              <ZoomInIcon className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-318" />
            </div>
          </button>)}
      </motion.div>
      {/* Lightbox */}
      <AnimatePresence data-id="element-319">
        {selectedImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setSelectedImage(null)} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-320">
            <motion.div initial={{
          scale: 0.9
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0.9
        }} className="relative max-w-4xl max-h-[90vh]" onClick={e => e.stopPropagation()} data-id="element-321">
              <button onClick={() => setSelectedImage(null)} className="absolute -top-12 right-0 p-2 text-white hover:text-slate-300 transition-colors" data-id="element-322">
                <XIcon className="w-6 h-6" data-id="element-323" />
              </button>
              <img src={selectedImage} alt="Full size" className="max-w-full max-h-[90vh] rounded-lg" data-id="element-324" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}